import script from "./footer-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer-menu.vue?vue&type=script&setup=true&lang=ts"

import "./footer-menu.vue?vue&type=style&index=0&id=7eb1fd72&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb1fd72"]])

export default __exports__